module.exports = __webpack_public_path__ + "3609f80c9d9f7622e5fa1d25c27eac69.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-miko.png
// module id = 603
// module chunks = 30